import React from 'react'
import Link from 'gatsby-link'
import logo from '../../images/logo_black_green_white.png'

const Header = () => (
  <section className="navbar navbar-fixed-top custom-navbar" background-color="#213565" role="navigation">
	<div className="container">
	 <div className="navbar-header">
			<button className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
				<span className="icon icon-bar"></span>
				<span className="icon icon-bar"></span>
				<span className="icon icon-bar"></span>
			</button>
			<a href="/">
        		<img src={logo} className="logo" />
        	</a>
		</div>
	 <div className="collapse navbar-collapse">
			<ul className="nav navbar-nav navbar-right">
				<li><a href="/#keynotes" className="smoothScroll">Speakers</a></li>
				<li><a href="/agenda" className="smoothScroll">Agenda</a></li>
				<li><a href="/#tickets" className="smoothScroll">Registration</a></li>
				<li><a href="/#workshops" className="smoothScroll">Workshops</a></li>
				<li><a href="/community-events/" className="smoothScroll">Community events</a></li>
				<li><a href="/blog/" className="smoothScroll">Blog</a></li>
				<li><a href="/#partners" className="smoothScroll">Partners</a></li>
				<li><a href="/#contact" className="smoothScroll">Contact</a></li>
			</ul>
		</div>
	</div>
</section>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js